import {SpacingType, BreakpointType} from '@nib-components/theme';

export const PRODUCT_TYPES = {
  HOSPITAL: 'hospital',
  EXTRAS: 'extras',
  COMBINED: 'combined'
} as const;

export const ANNUAL_LIMIT_TYPES = {
  INCREASING: 'Increasing',
  STATIC: 'Static Limit',
  NO_LIMIT: 'No Limit'
} as const;

export const COVER_TYPES = {
  INCLUSION: 'Inclusion',
  EXCLUSION: 'Exclusion',
  RESTRICTION: 'Restriction',
  MBP: 'MBP',
  R: 'R',
  INCL: 'Incl'
} as const;

export const COVER_TYPES_DESCRIPTIONS = {
  Inclusion: 'Included',
  Exclusion: 'Excluded',
  Restriction: 'Restricted',
  MBP: 'Minimum Benefits Payable',
  R: 'Restricted (Hospital Benefits Only)',
  Incl: 'Included (Hospital Benefits Only)'
} as const;

export const COVER_TYPES_TAG_TYPES = {
  Inclusion: 'success',
  Exclusion: 'error',
  Restriction: 'warning',
  MBP: 'dark',
  R: 'dark',
  Incl: 'dark'
} as const;

export const HOSPITAL_TIERS = {
  BASIC: 'Basic',
  BASIC_PLUS: 'Basic Plus',
  BRONZE: 'Bronze',
  BRONZE_PLUS: 'Bronze Plus',
  SILVER: 'Silver',
  SILVER_PLUS: 'Silver Plus',
  GOLD: 'Gold'
} as const;

export type PRODUCT_TYPES_Keys = keyof typeof PRODUCT_TYPES;
export type PRODUCT_TYPES_Values = (typeof PRODUCT_TYPES)[PRODUCT_TYPES_Keys];

export const TIER_SLUGS = ['basic', 'basic-plus', 'bronze', 'bronze-plus', 'silver', 'silver-plus', 'gold'] as const;
export type TIER_SLUGS_Values = (typeof TIER_SLUGS)[number];

type COVER_TYPES_Keys = keyof typeof COVER_TYPES;
export type COVER_TYPES_Values = (typeof COVER_TYPES)[COVER_TYPES_Keys];

export type Nullable<T> = T | null;

type PartialRecord<K extends keyof never, T> = {
  [P in K]?: T;
};

export type ResponsiveProp<T> = PartialRecord<BreakpointType, T>;
export type ResponsiveOrStaticProp<T> = T | ResponsiveProp<T>;
export type ResponsiveSpaceProp = ResponsiveOrStaticProp<Nullable<SpacingType>>;
export type ResponsiveHeightProp = ResponsiveOrStaticProp<Nullable<number>>;
